import { CreateOrgDialog } from "@components/FormFields/CreateOrgDialog";
import CustomSelectMenu from "@components/FormFields/CustomSelectMenu";
import { useAuth } from "@hooks/useAuth";
import useDialog from "@hooks/useDialog";
import { cn } from "@utils/index";
import { PlusIcon } from "lucide-react";

type Mutable<T> = {
  -readonly [P in keyof T]: T[P]
}

export default function OrganizationPicker() {
  const { openDialog } = useDialog()
  const { organization, setSelectedOrg, user } = useAuth();
  if (!user) return null

  const orgOptions = user.organizations

  return (
    <>
      <p className="text-muted">/</p>
      <CustomSelectMenu
        key={organization?.id ?? "" + "-" + organization?.profile?.id ?? ""}
        buttonClassName="border-none"
        className="max-h-96 w-72"
        footer={
          <button
            onClick={() => openDialog({
              title: "Create Organization",
              customContent: <CreateOrgDialog user={user} onSuccess={setSelectedOrg} />
            })}
            className="flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-sm font-medium text-muted-foreground hover:bg-accent hover:text-accent-foreground"
          >
            <PlusIcon className="h-4 w-4" />
            New organization
          </button>
        }
        selected={orgOptions.find((org) => org.profile?.id === organization?.profile?.id) ?? null}
        options={orgOptions as Mutable<typeof orgOptions>}
        onChange={(org) => {
          if (!org) return;
          setSelectedOrg(org);
        }}
        optionRender={(org) => (
          <div
            className={cn(
              "flex w-56 flex-col truncate",
            )}
          >
            <p className="w-full truncate font-medium">
              {org?.name ?? org.profile?.email ?? "Default Organization"}
            </p>
            {user?.system_role === "admin" && (
              <p className="w-full truncate">{org.profile?.email ?? "No email"}</p>
            )}
          </div>
        )}
        selectHint="Select Organization"
        selectedRender={(org) => org.name ?? org.profile?.email ?? "Default Organization"}
      />
    </>
  );
}
